import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=5e5ba37c&scoped=true"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"
import style0 from "./SideBar.vue?vue&type=style&index=0&id=5e5ba37c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5ba37c",
  null
  
)

export default component.exports